// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Mail: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 34" enableBackground="new 0 0 42 34" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M37.67,0.33H4.33c-2.29,0-4.15,1.88-4.15,4.17l-0.02,25
	c0,2.29,1.88,4.17,4.17,4.17h33.33c2.29,0,4.17-1.88,4.17-4.17v-25C41.83,2.21,39.96,0.33,37.67,0.33z M37.67,8.67L21,19.08
	L4.33,8.67V4.5L21,14.92L37.67,4.5V8.67z"/>
</svg>;
};

export default React.memo(Mail);
